module.exports = __webpack_public_path__ + "img/c05_unitfishingboat_Normal_ua.8d740aa1.webp";